import one from '../assets/svg/projects/one.jpg'
import two from '../assets/svg/projects/two.jpg'
import three from '../assets/svg/projects/three.jpg'
import four from '../assets/svg/projects/four.jpg'
import five from '../assets/svg/projects/five.jpg'
import six from '../assets/svg/projects/six.jpg'
import seven from '../assets/svg/projects/seven.jpg'
import eight from '../assets/svg/projects/eight.jpg'
import Nine from '../assets/svg/projects/Nine.jpg'
import ten from '../assets/svg/projects/ten.jpg'
import Eleven from '../assets/svg/projects/Eleven.jpg'
import twel from '../assets/svg/projects/twel.jpg'
import thirt from '../assets/svg/projects/thirt.jpg'
import fourteen from '../assets/svg/projects/fourteen.jpg'
import fifteen from '../assets/svg/projects/fifteen.jpg'
import sixteen from '../assets/svg/projects/sixteen.png'
import ninten from '../assets/svg/projects/ninten.png'
import ninteen from '../assets/svg/projects/ninteen.jpg'
import twenty from '../assets/svg/projects/twenty.jpg'
import twenty1 from '../assets/svg/projects/twenty1.jpg'
export const projectsData = [
    {
        id: 21,
        projectName: 'HomeVista: Streamlined Property Management Solution',
        projectDesc: 'Enabled image upload, edit, and delete functions, empowering users with enhanced control and experience management.Developed dynamic search functionality with customizable filters, enabling effortless property browsing experiences. Implemented robust user authentication, ensuring seamless and secure access to all HomeHub’s features for users ',
        tags: ['Javascript','React', 'Express', 'MongoDB', 'Node.js','JWT', 'Redux-toolkit', 'Tailwind CSS', 'JWT', 'Firebase'],
        code: 'https://github.com/sainath-kadam',
        demo: 'https://kadam-estate.onrender.com/',
        image: twenty1
    },
  {
        id:  2,
        projectName: 'Money-Mind: Simplified Financial Tracking',
        projectDesc: 'Efficient website for financial tracking, facilitating users with 5+ features for income, expense, and savings management. ',
        tags: ['JSX', 'CSS', 'Javascript','React', 'Express', 'MongoDB', 'Node.js'],
        code: 'https://github.com/sainath-kadam/Income_Expenditure_Saving',
        demo: 'https://sainathkdmlocker.netlify.app/',
        image: Eleven
    },
    {
        id: 1,
        projectName: 'AskTask: Help Within Reach ',
        projectDesc: 'Empower campus communities with a secure platform, enhancing knowledge access by 30%. Facilitating a seamless transition between offline and online interactions, resulting in 20% enhancement in engagement ',
        tags: ['JSX', 'CSS', 'Javascript','React', 'Express', 'MongoDB', 'Node.js','JWT', 'Redux'],
        code: 'https://github.com/sainath-kadam',
        demo: 'https://asktask4u.netlify.app/',
        image: sixteen
    },
    {
        id:  5,
        projectName: 'Gyan Dhara :Counseling Website ',
        projectDesc: 'Created a counseling website with 5+ interactive features for effective communication and improved user engagement.  ',
        tags: ['JSX', 'CSS', 'Javascript','React', 'Vite','Telwind'],
        code: 'https://github.com/sainath-kadam/Gyan-Dhara_website-Counselling-website-',
        demo: 'https://gyan-dhara-counsellingcenter.netlify.app',
        image: thirt
    },
    {
        id: 1,
        projectName: 'Career-Ready: Empowering Placement Success',
        projectDesc: 'Enhanced placement preparation website, intuitive UI, personalized 100+ questions, seamless video meeting integration. ',
        tags: ['JSX', 'CSS', 'Javascript','React', 'Express', 'MongoDB', 'Node.js','JWT', 'Redux'],
        code: 'https://github.com/sainath-kadam',
        demo: 'https://hack-horizons-iiitt.netlify.app/',
        image: ninten
    },
    {
        id:  6,
        projectName: 'Restaurants UI',
        projectDesc: 'This  Website is build for UI  designing purpose  ',
        tags: ['JSX', 'CSS', 'Javascript','React'],
        code: 'https://github.com/sainath-kadam/Restaurant-_UI_React_Design-',
        demo: 'https://kadam-restaurant.netlify.app ',
        image: three
    },
    {
        id:  7,
        projectName: 'Disney Plus UI',
        projectDesc: 'build Disney Plus UI Clone and Deployed ',
        tags: ['JSX', 'SCSS', 'Javascript','React',],
        code: 'https://github.com/sainath-kadam/Disney-Clone-UI',
        demo: 'https://disney-plus-ui-by-sai.netlify.app',
        image: Nine
    },
    {
        id: 17,
        projectName: 'Add Product UI',
        projectDesc: 'Build a website for adding product with best UI design with backend part',
        tags: ['React',"Styelcomponents","Nodejs","Mongodb","Express"],
        code: 'https://github.com/sainath-kadam/DevTown_Assigment',
        demo: 'https://devtown-sainathkadam.netlify.app/',
        image: ninteen
    },

    {
        id: 1,
        projectName: 'Doctor Appoinment',
        projectDesc: 'This  Webiste is build for the appoinment of doctor, there are 3 person who can login admin,doctor,user and all of them have unique feature  as per their role ',
        tags: ['JSX', 'CSS', 'Javascript','React', 'Express', 'MongoDB', 'Node.js','JWT', 'Redux'],
        code: 'https://github.com/sainath-kadam/Appoinment-of-Doctor',
        demo: 'https://drive.google.com/file/d/1N0iNtQPFSQGB0xcmSnktmRYkIyntuobE/view?usp=drivesdk',
        image: two
    },
     {
        id: 3,
        projectName: 'Book Store',
        projectDesc: 'This project is  a  website where we can  do CRUD Operation ',
        tags: ['JSX', 'CSS', 'Javascript','React', 'Express', 'MongoDB', 'Node.js'],
        code: 'https://github.com/sainath-kadam/bookstore',
        demo: 'https://drive.google.com/file/d/1iR9WK8AUFQK3Lrms98HGD3bJlQaU5qo7/view?usp=drivesdk ',
        image: fourteen
    },

     {
        id: 4,
        projectName: 'Movie Review',
        projectDesc: 'This project is  a  website where we fetched API and  can perform CRUD Operation ',
        tags: [ 'API','JSX', 'CSS', 'Javascript','React', 'Express', 'MongoDB', 'Node.js' ],
        code: 'https://github.com/sainath-kadam/Movie_Review_sytem_MERN',
        demo: '',
        image: seven
    },
   

     {
        id: 8,
        projectName: 'Authentication',
        projectDesc: 'This is the clone of reliancedigital.in. Features I worked on the Product Catalogue pages and also on some minor parts on other pages as well',
        tags: ['React', 'Express', 'MongoDB', 'Node.js'],
        code: 'https://github.com/sainath-kadam/Login-Register-sysytem-MERN',
        demo: '',
        image: twenty
    },
     {
        id:  9,
        projectName: 'Movie in Hall',
        projectDesc: 'build  movie webiste by  fetching API & deployed ',
        tags: ['JSX', 'CSS', 'Javascript','React',],
        code: 'https://github.com/sainath-kadam/Movie_in_Hall',
        demo: 'https://moviewithsai.netlify.app',
        image: six
    },
    
   
   
    {
        id: 10,
        projectName: 'SnapShot',
        projectDesc: 'This project I have build using,React & fetched API',
        tags: ['React'],
        code: 'https://github.com/sainath-kadam/Snap',
        demo: '',
        image: one
    },
     {
        id:  11,
        projectName: 'Git4U',
        projectDesc: 'build a git profile webiste by  fetching API Deployed ',
        tags: ['HTML', 'CSS'],
        code: 'https://github.com/sainath-kadam/git_profile',
        demo: 'https://git4u-bysainath.netlify.app(',
        image: twel
    },
    {
        id: 12,
        projectName: 'Hospital Management',
        projectDesc: 'This project is Full functional build for Hospital Management Sysytem',
        tags: ['React', 'Express', 'MongoDB', 'Node.js'],
        code: 'https://github.com/sainath-kadam/Hospital',
        demo: '',
        image: fifteen
    },
 
    {
        id: 13,
        projectName: 'E-commmercial Website ',
        projectDesc: 'This is a clone of an e-commerce website sportsjam.in. My contribution to this project was the product catalogue page and its features, like sorting and filtering. The rest of the project was built by various members of the group',
        tags: ['HTML', 'CSS','Django','Javascript'],
        code: 'https://github.com/sainath-kadam/Startup-Quirky',
        demo: '',
        image: ten
    },
    {
        id: 14,
        projectName: 'Blog ',
        projectDesc: 'This project seeks to explore Blog Written By people for people. I have a fullstack role in this having built all of it.',
        tags: ['Django', 'HTML' ,'CSS', 'Javascript'],
        code: 'https://github.com/sainath-kadam/blog-version-2',
        demo: 'https://drive.google.com/file/d/1iuPtjKTchhYhCaYIviLdi9Z4fNUg01Bw/view?usp=drivesdk',
        image: five
    },
    
    {
        id: 15,
        projectName: 'Calculator ',
        projectDesc: 'This project  i have created a Calculator using React',
        tags: ['React'],
        code: 'https://github.com/sainath-kadam/Calculator-',
        demo: ' https://calculatewith-sainath-kadam.netlify.app',
        image: four
    },
    {
        id: 16,
        projectName: '360 View ',
        projectDesc: 'Build a 360 View  uisng Panorama library',
        tags: ['HTML',"Css"],
        code: 'https://github.com/sainath-kadam/internship_project',
        demo: 'https://belgain-sport-360-view-sainath-kadam.netlify.app',
        image: eight
    },
  
       
]

